<template>
  <div class="p-6">
    <h3 class="text-lg font-semibold text-gray-800 mb-6">
      Select Consultation Service <span class="text-red-500">*</span>
    </h3>

    <div v-if="loading" class="text-center py-8">
      <svg class="animate-spin h-8 w-8 text-custom-yellow mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="mt-4 text-gray-600">Loading consultation services...</p>
    </div>

    <div v-else-if="consultationServices.length === 0" class="text-center py-8 text-gray-500">
      No consultation services configured for this facility.
    </div>

    <div v-else class="space-y-4">
      <div
        v-for="service in consultationServices"
        :key="service.id"
        class="flex items-center justify-between p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition"
        :class="{ 'border-custom-yellow bg-yellow-50': selectedId === service.id }"
        @click="selectService(service)"
      >
        <div class="flex items-center">
          <input
            type="radio"
            :id="service.id"
            :value="service.id"
            v-model="selectedId"
            class="h-5 w-5 text-custom-yellow focus:ring-custom-yellow"
          />
          <label :for="service.id" class="ml-4 cursor-pointer block">
            <div class="font-medium text-gray-900">{{ service.name }}</div>
            <div v-if="service.is_cash" class="text-sm text-gray-600">Cash payment</div>
          </label>
        </div>
        <div class="text-xl font-bold text-custom-blue">
          KES {{ formatPrice(service.unit_price) }}
        </div>
      </div>
    </div>

    <!-- <div v-if="error" class="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
      {{ error }}
    </div> -->

    <!-- Optional: subtle hint if nothing selected -->
    <div v-if="!loading && consultationServices.length > 0 && !selectedId" class="mt-4 text-sm text-gray-600">
      Please select a consultation type to continue.
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/api"

export default {
  name: "PatientConsultationService",
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      patientRegForm: { ...this.formData },
      consultationServices: [],
      selectedId: null,
      loading: true,
      error: null
    }
  },
  watch: {
    selectedId(newVal) {
      const service = this.consultationServices.find(s => s.id === newVal);
      this.patientRegForm.patient.consultation_service = service ? {
        id: service.id,
        name: service.name,
        unit_price: service.unit_price
      } : null;

      this.$emit("update:formData", this.patientRegForm);
    }
  },

  mounted() {
    this.fetchConsultationServices();
  },

  methods: {
    async fetchConsultationServices() {
      try {
        this.loading = true;
        this.error = null;

        const response = await apiClient.getConsultationServices();
        console.log(response, 'consultation services');
        if (response.success)
          this.consultationServices = response.data;

          if (this.patientRegForm.patient.consultation_service?.id) {
            this.selectedId = this.patientRegForm.patient.consultation_service.id;
          }
        else {
          this.error = response.message || "Failed to fetch consultation services"
        }

      } catch (err) {
        this.error = "Unable to connect to server. Please try again"
      } finally {
        this.loading = false;
      }
    },

    selectService(service) {
      this.selectedId = service.id
    },

    formatPrice(value) {
      return Number(value).toLocaleString('en-KE', { minimumFractionDigits: 0 });
    }
  }
}
</script>

<style scoped>
/* Optional: improve radio button alignment */
input[type="radio"] {
  cursor: pointer;
}
</style>